import classNames from 'classnames';
import { format } from 'date-fns';
import { useTranslation } from 'next-i18next';
import React from 'react';

import { getApprovalStatus } from '@/modules/home/components/PageContent/Approvals/logic';
import { IHome } from '@/modules/home/types';
import { Typography } from '@/shared/components/atoms';
import { clsxm } from '@/shared/lib';

const HomeApprovalDetails: React.FC<{
  data: IHome.IApprover[];
  id: number;
}> = ({ data, id }) => {
  const { t } = useTranslation();

  return (
    <div className='p-16'>
      <div className='mb-8 border-b-xs border-background-neutral-100 pb-8'>
        <Typography weight='bold'>{t('Approval Details')}</Typography>
        <Typography variant='caption' className='text-surface-10'>{`${t(
          'Operation'
        )} #${id}`}</Typography>
      </div>
      {data.map((item, idx) => (
        <div
          key={`${item.approvalStatus}${item.statusUpdateDate}${idx}`}
          className='flex items-center gap-16 px-16 py-8'
        >
          <div
            className={classNames(
              'relative flex h-40 w-40 items-center justify-center rounded-full',
              idx < data.length - 1 &&
                'after:absolute after:top-full after:h-full after:w-[1px] after:bg-neutralVariant-90',
              getApprovalStatus(item.approvalStatus, item.activeApprover)
                .circleBg,
              getApprovalStatus(item.approvalStatus, item.activeApprover).color
            )}
          >
            {getApprovalStatus(item.approvalStatus, item.activeApprover).icon}
          </div>
          <div className='whitespace-nowrap'>
            <Typography
              weight='medium'
              variant='caption'
              className='text-surface-10'
            >
              {t(
                getApprovalStatus(item.approvalStatus, item.activeApprover)
                  .message
              )}
              {item.statusUpdateDate !== null &&
              getApprovalStatus(item.approvalStatus, item.activeApprover)
                .status !== 'pending'
                ? ` - ${format(
                    new Date(item.statusUpdateDate),
                    'M/dd/yyyy, h:mm aaa'
                  )}`
                : ''}
            </Typography>
            <Typography weight='semiBold' className='flex items-center gap-2'>
              <span
                className={clsxm(
                  item.activeApprover === 0 && 'text-surface-10'
                )}
              >
                {item.approverName}
              </span>
              {item.activeApprover === 0 && (
                <span className='rounded-md bg-neutralVariant-90 py-1 px-2 text-12 font-regular'>
                  {t('inactive')}
                </span>
              )}
            </Typography>
            <Typography variant='subtitle2' className='text-surface-10'>
              {item.approverJobTitle}
            </Typography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomeApprovalDetails;
